import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Observable } from "rxjs";
import { shareReplay, tap } from "rxjs/operators";
import { EIPProjectService } from "src/app/shared/generated/api/eip-project.service";
import { LoadingDirective } from "src/app/shared/directives/loading.directive";
import { EIPProjectDetail } from "src/app/shared/generated/model/eip-project-detail";
import { ProjectTitleComponent } from "../project-title/project-title.component";

import { FieldDefinitionComponent } from "src/app/shared/components/field-definition/field-definition.component";

import { AreaLinkDirective } from "src/app/shared/directives/area-link.directive";
@Component({
    selector: "app-project-detail-popup",
    standalone: true,
    imports: [CommonModule, LoadingDirective, ProjectTitleComponent, FieldDefinitionComponent, AreaLinkDirective],
    templateUrl: "./project-detail-popup.component.html",
    styleUrls: ["./project-detail-popup.component.scss"],
})
export class ProjectDetailPopupComponent implements OnInit {
    project$: Observable<EIPProjectDetail>;
    isLoading: boolean = true;

    @Input() projectId: number;

    constructor(private eipProjectService: EIPProjectService) {}

    ngOnInit(): void {
        this.project$ = this.eipProjectService.getEIPProject(this.projectId).pipe(
            tap(() => (this.isLoading = false)),
            shareReplay(1)
        );
    }
}
